<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
					<div class="row pb-4">
            <div class="col">
              <h3 class="p-0">FRT - Extend Closing Date</h3>
            </div>
            <div class="col text-right">
							<div class="dropdown">
								<button type="button" class="btn btn-outline-secondary btn-more w-auto rounded-circle" id="more-options" data-toggle="dropdown" aria-label="More Options" aria-haspopup="true" aria-expanded="false">
									<span class="ellipsis" aria-hidden="true">&#8943;</span>
							  </button>

                <div class="dropdown-menu dropdown-menu-right">
									<h6 class="dropdown-header text-uppercase px-4">More Options</h6>
									<a class="dropdown-item" routerLink="/frtratesbidcyles" routerLinkActive="active">Open Rate Filing</a>
							  </div>
							</div>
            </div>
          </div>


          <div *ngIf="updateSuccessful" class="alert alert-success">
						Your TSP extension has been successfully updated.
          </div>
          <div *ngIf="updateFailure" class="alert alert-danger">
             {{errorMessage}}
          </div>

          <form [formGroup]="frtRateFileTspExtForm" >
            <div class="form-row">
              <div class="form-group col-md-2">
                <label for="open_bidcycles">Open Bid Cycles <small class="required">*</small></label>
                <select id="open_bidcycles" class="w-100" formControlName="openBidcycles"
                   (change)="onBidcyclesChange($event.target.value)">>
                  <option value='' selected disabled>Choose...</option>
                  <option *ngFor="let currentBidcycle of currentBidcycles"
                   [value]="currentBidcycle.ratesBidcyclesId">{{currentBidcycle.bidCycleName}} </option>
                </select>
              </div>
              <div class="form-group col-md-2" >
                <label for="scac">SCAC<small class="required">*</small></label>
                <input type="text"  oninput="this.value = this.value.toUpperCase()"
                  id="scac" class="w-100" placeholder="Enter Keyword" formControlName='carrierKeyword'
                  [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10"
                  [maxlength]="maxCharLength" (blur)="onScacSelect($event.target.value)">
              </div>
              <div class="form-group col-md-2">
                  <label for="tsp_open_date">Bid Cycle Open Date</label>
                  <input id="tsp_open_date" type="text" id="bid_open_date" class="w-100" placeholder="mm/dd/yyyy"
                  [value]="this.frtRateFileTspExtForm.get('bidOpenDate').value | date: 'MMM d, y'"
                    formControlName="bidOpenDate" readonly>
                </div>
                <div class="form-group col-md-2">
                    <label for="close_date">Bid Cycle Close Date<small class="required">*</small></label>
                    <input id="close_date" type="text" id="bid_close_date" class="w-100" placeholder="mm/dd/yyyy"
                    formControlName="bidCloseDate" (bsValueChange)="bidCloseDateChange($event)"
                    [minDate]="bidCloseMinDate"
                    [value]="this.frtRateFileTspExtForm.get('bidCloseDate').value | date: 'MMM d, y'"
                    [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }" placement="right">
                  </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="carrierName">TSP Name</label>
                  <input type="text" id="carrierName" class="w-100" readonly
                    formControlName="carrierName" >
                </div>
                <div class="form-group col-md-4">
                    <label for="addlText">Additional Text</label>
                    <input type="text" id="addlText" class="w-100" formControlName="addlText"
                     (change) = "onAddlText($event.target.value)"	>
                  </div>
              </div>
              <div class="mt-4">
                  <div class="mt-4">
                    <button type="button" class="btn btn-primary w-auto"
                    [disabled]="disableSaveBtn"
                    (click)="saveRateExtRec()" >Save</button>
                    <button type="button" class="btn btn-outline-secondary w-auto ml-4 "
                    (click)="clearPage()">Cancel</button>
                  </div>
                </div>
					</form>
				</div>
			</div>
    </div>
  </div>
  <div class="card-body p-5">
    <div class="table-responsive">
        <ag-grid-angular class="ag-theme-alpine"
          [rowData]="allRateTspExt"
          [domLayout]="domLayout"
          [pagination]="true"
          [paginationPageSize]="itemsPerPage"
          [columnDefs]="rateTspExtColumnDefs">
      </ag-grid-angular>

  </div>
</div>
</div>

